import { useAxiosPost } from "../../axios";

export const syncKustomerData = async (data: any) => {
  await useAxiosPost("/kustomer/update", data);
};
